import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { 
  setAccountModalOpen,
  get_company_users,
  get_company_list,
  create_account,
  activate_deactivate_users,
  get_user_details,
  update_account,
  setSearchQuery,
  setPage,
  setId,
  setAction,
  get_company_process
} from "../../../store/account/accountSlice";

const mapStateToProps = (state) => {
  const { 
    is_account_modal_open,
    common_loading,
    total_users_count,
    active_users,
    page,
    user_id,
    c_action,
    selected_data,
    company_list
  } = state.account;
  return {
    is_account_modal_open : is_account_modal_open,
    total_users_count : total_users_count,
    common_loading : common_loading,
    active_users : active_users,
    page : page,
    selected_data : selected_data,
    user_id : user_id,
    c_action : c_action,
    company_list : company_list
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    setAccountModalOpen,
    get_company_users,
    get_company_list,
    create_account,
    activate_deactivate_users,
    get_user_details,
    update_account,
    setSearchQuery,
    setPage,
    setId,
    setAction,
    get_company_process    
  }, dispatch);

const Store = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;
